import { Select, Button1, Button2, Radio, TagInput } from "../index";
import plusIcon from "../../assets/icons/plus-circle-white.png";
import mastercardIcon from "../../assets/images/mastercard.png";
import visacardIcon from "../../assets/images/visa.png";
import americanexpresscardIcon from "../../assets/images/american_express.png";
import { Input } from "antd";
import { useState } from "react";
import { accountsApi } from "../../api/endpoints";

const CATEGORIES = ["Top-up", "Salary", "Refund", "Other"];

const cardOptions = [
  {
    cardIcon: mastercardIcon,
    cardName: "Mastercard",
    cardNumber: "**********3451",
  },
  {
    cardIcon: visacardIcon,
    cardName: "Visa",
    cardNumber: "**********3451",
  },
  {
    cardIcon: americanexpresscardIcon,
    cardName: "American Express",
    cardNumber: "**********3451",
  },
];

const CreditDebitCard = ({
  accounts = [],
  targetAccountId,
  setTargetAccountId,
  targetAccount,
  onSuccess,
}) => {
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const [selectedCardKey, setSelectedCardKey] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Only AUD accounts are accepted for Add Funds at this time
  const audAccounts = accounts.filter((a) => a.currency === "AUD");
  const accountOptions = audAccounts.map((a) => ({
    name: `${a.currency} ****${(a.iban || a.accountNumber || "0000").slice(-4)}${
      a.isDefault ? " (Default)" : ""
    }`,
    value: a.id,
  }));

  const processDetails = [
    { name: "Transfer fee", detail: "10 AUD" },
    { name: "Speed", detail: "0-1 day" },
    { name: "Transfer limit", detail: "No limit" },
  ];

  const handleSubmit = async () => {
    setError(null);
    setSuccess(null);
    if (!targetAccountId) {
      setError("Please select an account to top up");
      return;
    }
    if (!amount || Number(amount) <= 0) {
      setError("Enter a valid amount");
      return;
    }
    setSubmitting(true);
    try {
      const res = await accountsApi.topup(targetAccountId, Number(amount));
      setSuccess(
        res?.message ||
          `Deposit pending, Ref: ${res?.reference}. ${amount} ${
            targetAccount?.currency || "AUD"
          } will be credited in ~1 hour.`
      );
      setAmount("");
      onSuccess?.();
    } catch (e) {
      setError(
        e.response?.data?.error || e.message || "Top up failed"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-5 mb-5  p-3">
        <span className="fs-5 fw-bold">Add Funds Via Credit/Debit Card</span>
        <div className="d-flex flex-column mt-4 gap-2">
          <span className="fs14px">Top up to account</span>
          <Select
            value={targetAccountId}
            options={accountOptions}
            defaultValue="Select your account"
            className="rounded-2 p-3"
            onChange={(e) => setTargetAccountId(e.target.value)}
          />
        </div>

        <div className="d-flex flex-column mt-2">
          <div className="d-flex gap-3 ">
            <div className="w-75">
              <label className="fs12px">Amount</label>
              <Input
                className="p-3 w-100"
                placeholder="0.00"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div>
              <label className="fs12px">Currency</label>
              <Select
                value={targetAccount?.currency || "AUD"}
                options={[
                  {
                    name: targetAccount?.currency || "AUD",
                    value: targetAccount?.currency || "AUD",
                  },
                ]}
                className="p-3 "
                selectStyle={{ width: "100%" }}
                disabled
              />
            </div>
          </div>
          {targetAccount && (
            <span className="fs12px mt-2">
              Current balance:{" "}
              {Number(targetAccount.availableBalance).toLocaleString()}{" "}
              {targetAccount.currency}
            </span>
          )}
        </div>
      </div>

      <div className="col-lg-6 mb-5  p-3">
        <div className="d-flex flex-column ">
          <span className="fs-5 fw-bold">Additional Details</span>
          <div className="d-flex flex-column gap-1 mt-4">
            <label className="fs12px ">Category</label>
            <Select
              value={category}
              options={CATEGORIES.map((c) => ({ name: c, value: c }))}
              defaultValue="Choose Category"
              className="rounded-2 p-3"
              onChange={(e) => setCategory(e.target.value)}
            />
          </div>
          <div className="d-flex flex-column gap-1 mt-3">
            <label className="fs12px ">Tags</label>
            <TagInput
              className="border py-3"
              inputBgColor="transparent"
              tagColor="#1bbb6b"
              tagTextColor="#000"
              limit={10}
              placeholder="Add up to 10 Tags"
            />
          </div>
        </div>

        <div className="d-flex flex-column gap-3 mt-5">
          <div className="d-flex justify-content-between  align-items-center">
            <span className="fs-5 fw-bold">Process Payment</span>
            <Button2
              icon={<img src={plusIcon} alt="add" />}
              buttonName={"New Card"}
              className={"btn-dark p-1 px-3"}
              divClassName={"gap-2 "}
            />
          </div>
          <span className="fs12px" style={{ color: "#7D7D7D" }}>
            Payment method
          </span>

          <div className="d-flex flex-wrap gap-2 ">
            {cardOptions.map((card, key) => (
              <div
                key={key}
                className={`d-flex align-items-center  justify-content-between p-3 rounded-2 payment-method-card ${
                  key === selectedCardKey ? "selected-card" : "border"
                }`}
              >
                <div className="d-flex align-items-center gap-2">
                  <img src={card.cardIcon} alt={card.cardName} />
                  <div className="d-flex flex-column">
                    <span className="fs14px" style={{ color: "#636363" }}>
                      {card.cardName}
                    </span>
                    <span className=" fw-medium" style={{ color: "#161616" }}>
                      {card.cardNumber}
                    </span>
                  </div>
                </div>

                <Radio
                  height={"24px"}
                  width={"24px"}
                  accentColor={"green"}
                  name={"card"}
                  checked={key === selectedCardKey}
                  onClick={() => setSelectedCardKey(key)}
                />
              </div>
            ))}
          </div>

          <div
            className="d-flex justify-content-around p-3 rounded-3"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            {processDetails.map(({ name, detail }) => (
              <div key={name} className="d-flex flex-column gap-2">
                <span className="fs12px" style={{ color: "#7D7D7D" }}>
                  {name}
                </span>
                <span className="fw-medium">{detail}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {error && (
        <div className="col-12 p-2">
          <span className="fs12px" style={{ color: "#FC555B" }}>
            {error}
          </span>
        </div>
      )}
      {success && (
        <div className="col-12 p-2">
          <span className="fs12px" style={{ color: "#1bbb6b" }}>
            {success}
          </span>
        </div>
      )}

      <div className="d-flex justify-content-end p-2 gap-3">
        <Button1 buttonName={"Save as Draft"} className={"btn-outline-success"} />
        <Button1
          buttonName={submitting ? "Processing..." : "Add Funds"}
          className="btn-dark "
          onClick={handleSubmit}
          disabled={submitting}
        />
      </div>
    </>
  );
};

export default CreditDebitCard;
